import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, CloseOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Contract/doview2', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Contract/view2', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id,
                    dwtype: 1
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (this.state.condition.id) {
                        that.setState({
                            condition: data.data,
                        })
                    }
                    that.setState({
                        room_react: data.room_react ? data.room_react : [],
                        yq_react: data.yq_react ? data.yq_react : [],
                        company_react: data.company_react ? data.company_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, {editorState: editorState, dwjj: editorState.toHTML()})
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, {[name]: fjlist})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {[name]: fjlist})
        this.setState({
            condition: data,
        })
    }

    onSelSearch = (name, value) => {
        let that = this
        let condition = Object.assign({}, this.state.condition, {newfield: value})
        that.setState({
            condition,
        })
        fetch('/Ajax/searchCompany', {
            method: "POST",
            body: JSON.stringify({
                name: value,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    [name]: data
                })
            })

    }
    addItem_qiye = () => {
        let that = this
        let newfield = that.state.condition.newfield
        fetch('/Check/AddCompany', {
            method: "POST",
            body: JSON.stringify({
                newfield
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    let condition = Object.assign({}, this.state.condition, {
                        newfield: null,
                        company_id: data.company_id ? data.company_id : null
                    })
                    this.setState({
                        condition: condition,
                        company_react: data.company_react ? data.company_react : []
                    })
                } else {
                    message.error(data.msg)
                }
            })
    }

    clearNewField = (open) => {
        let that = this
        setTimeout(() => {
            let condition = Object.assign({}, that.state.condition, {newfield: null})
            that.setState({
                condition: condition,
            })
        });
    }

    addjfbz() {
        let jfbz = this.state.condition.jfbz ? this.state.condition.jfbz.concat() : []
        let newArr = {}
        jfbz.push(newArr)
        let data = Object.assign({}, this.state.condition, {jfbz})
        this.setState({
            condition: data
        })
    }

    deljfbz(index, e) {
        let jfbz = this.state.condition.jfbz ? this.state.condition.jfbz.concat() : []
        jfbz.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {jfbz})
        this.setState({
            condition: data,
        })
    }

    onChange2(name, name2, index, e) {
        let value = e.target.value
        let arr = this.state.condition[name2][index]
        let list = this.state.condition[name2]
        let data = Object.assign({}, arr, {[name]: value})
        list[index] = data
        let data2 = Object.assign({}, this.state.condition, {[name2]: list})
        this.setState({
            condition: data2
        })
    }

    render() {

        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={this.mdchange.bind(this)}>新增合同</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="企业名称"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.company_id ? this.state.condition.company_id : []}
                                        onChange={this.onSelChange.bind(this, 'company_id')}
                                        onSearch={this.onSelSearch.bind(this, 'company_react')}
                                        onDropdownVisibleChange={this.clearNewField.bind(this)}
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <>
                                                    <Divider
                                                        style={{
                                                            margin: '8px 0',
                                                        }}
                                                    />
                                                    <Space
                                                        style={{
                                                            padding: '0 8px 4px',
                                                        }}
                                                    >
                                                        <Input placeholder="请输入"
                                                               style={{width: 250}}
                                                               value={this.state.condition.newfield ? this.state.condition.newfield : null}
                                                               onChange={this.onChange.bind(this, 'newfield')}/>
                                                        <Button type="text" icon={<PlusOutlined/>}
                                                                onClick={this.addItem_qiye.bind(this)}>
                                                            创建并选择
                                                        </Button>
                                                    </Space>
                                                </>
                                            </>
                                        )}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.company_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="合同编号"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.ref ? this.state.condition.ref : null}
                                           onChange={this.onChange.bind(this, 'ref')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="生效时间"
                                    required={true}
                                >
                                    <RangePicker style={{width: '100%'}} allowEmpty={[true, true]}
                                                 onChange={this.onRangeChange.bind(this, 'time')}
                                                 value={[(this.state.condition.time1 ? moment(this.state.condition.time1) : null), (this.state.condition.time2 ? moment(this.state.condition.time2) : null)]}
                                                 placeholder={['请输入', '请输入']}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="时长"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.duration ? this.state.condition.duration : null}
                                           onChange={this.onChange.bind(this, 'duration')} suffix={"小时"}/>
                                </Form.Item>
                            </Col>
                            {/*<Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="所属园区"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.yq_id ? this.state.condition.yq_id : []}
                                        onChange={this.onSelChange.bind(this, 'yq_id')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.yq_react)}
                                    </Select>
                                </Form.Item>
                            </Col>*/}
                            {/*<Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="金额"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.amount ? this.state.condition.amount : null}
                                           onChange={this.onChange.bind(this, 'amount')} suffix={"元"}/>
                                </Form.Item>
                            </Col>*/}
                            {/*<Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="计费标准"
                                    // required={true}
                                >
                                    <TextArea placeholder="请输入"
                                              rows={4}
                                              value={this.state.condition.jfbz ? this.state.condition.jfbz : null}
                                              onChange={this.onChange.bind(this, 'jfbz')}/>
                                </Form.Item>
                            </Col>*/}
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="附件"
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'fjlist')}
                                                multiple={true}
                                                data={{
                                                    pc: 1
                                                }}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap>
                                                {this.state.condition.fjlist ? this.state.condition.fjlist.map((item, index) =>
                                                    <div>
                                                        <a href={item.url} target="_blank">{item.name} </a>
                                                        <DeleteOutlined className="hongse"
                                                                        onClick={this.delpic.bind(this, index, 'fjlist')}/>
                                                    </div>) : null}

                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Divider>计费标准</Divider>
                            </Col>
                            {this.state.condition.jfbz ? this.state.condition.jfbz.map((item, index) =>
                                <>
                                    <Col className="gutter-row" span={11}>
                                        <Form.Item
                                            label="区间"
                                        >
                                            <Space>
                                                <Input placeholder="请输入" value={item.num1}
                                                       onChange={this.onChange2.bind(this, 'num1', 'jfbz', index)}
                                                        suffix={'小时'}
                                                />
                                                <span>-</span>
                                                <Input placeholder="请输入" value={item.num2}
                                                       onChange={this.onChange2.bind(this, 'num2', 'jfbz', index)}
                                                        suffix={'小时'}
                                                />
                                            </Space>

                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={6}>
                                        <Form.Item
                                            label="金额"
                                        >
                                            <Input placeholder="请输入" value={item.amount}
                                                   onChange={this.onChange2.bind(this, 'amount', 'jfbz', index)}
                                                   suffix={'元/小时'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={1}>
                                        <Form.Item
                                            label=" "
                                        >
                                            <Popconfirm
                                                title="确认删除?"
                                                onConfirm={this.deljfbz.bind(this, index)}
                                                onCancel={() => {
                                                }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a><CloseOutlined style={{color: '#aaa', fontSize: 16}}/></a>
                                            </Popconfirm>
                                        </Form.Item>

                                    </Col>
                                </>
                            ) : null}
                            <Col className="gutter-row" span={24}>
                                <a onClick={this.addjfbz.bind(this)} style={{marginBottom: 15}}>+添加</a>
                            </Col>

                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
